import styled from 'styled-components';

import DayColumn from './DayColumn';

interface WeekViewGridProps {
  daysOfWeek: Date[];
}

export default function WeekViewGrid({ daysOfWeek }: WeekViewGridProps) {
  return (
    <GridContainer>
      {daysOfWeek.map((date) => (
        <DayColumn key={date.toISOString()} date={date} />
      ))}
    </GridContainer>
  );
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  flex: 1;
  min-height: 0;
  border: 1px solid ${({ theme }) => theme.colors.black15};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
`;
